/**
 * Una tabla de etiquetas que siempre está en el idioma actual, aunque se declare como
 * constante de módulo: `export const TIPOS = vivo(() => tx.comun.tipoEquipo)`. Se puede
 * leer, recorrer con Object.entries/keys y preguntar `k in TIPOS` como un objeto común.
 */
export function vivo<T extends object>(f: () => T): T {
  return new Proxy({} as T, {
    get: (_, k) => Reflect.get(f(), k),
    has: (_, k) => Reflect.has(f(), k),
    ownKeys: () => Reflect.ownKeys(f()),
    getOwnPropertyDescriptor: (_, k) => {
      const d = Reflect.getOwnPropertyDescriptor(f(), k);
      return d ? { ...d, configurable: true } : undefined;
    },
  });
}
